import { render } from "./TaskRichText.vue?vue&type=template&id=54c21caf"
import script from "./TaskRichText.vue?vue&type=script&lang=js"
export * from "./TaskRichText.vue?vue&type=script&lang=js"

import "./TaskRichText.vue?vue&type=style&index=0&id=54c21caf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__